var _rect, _rect2, _g, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27,
    width: 340,
    height: 200,
    rx: 5,
    fill: "#E3E8EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 78,
    width: 216,
    height: 16,
    rx: 1,
    fill: "#C1C9D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.85 110H111.151C110.731 110 110.311 110.018 109.893 110.054C101.555 110.764 95.3583 118.251 96.0532 126.777L96.764 135.499C97.4244 143.601 104.049 149.834 112 149.834C119.952 149.834 126.576 143.601 127.237 135.499L127.948 126.777C127.983 126.349 128 125.92 128 125.491C128 116.935 121.217 110 112.85 110Z",
    fill: "#C1C9D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.797 155.558C117.815 155.558 121.187 152.583 127.601 152.583C144 152.583 144 168.952 144 168.952V177.245C144 177.798 143.552 178.245 143 178.245H140H84H81C80.4477 178.245 80 177.798 80 177.245V168.952C80 168.952 80 152.583 96.3994 152.583C104.094 152.583 105.779 155.558 111.797 155.558Z",
    fill: "#C1C9D2"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 110,
    width: 135,
    height: 8,
    rx: 1,
    fill: "#C1C9D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 126,
    width: 100,
    height: 8,
    rx: 1,
    fill: "#C1C9D2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 142,
    width: 60,
    height: 8,
    rx: 1,
    fill: "#C1C9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.87b39493258fa3592efabccf960a3a06.svg";
export { ForwardRef as ReactComponent };